<template>
    <div>
        <v-row>
          <v-col>
            <div v-if="!!$attrs.value.accessToken">ขณะนี้ เชื่อมต่อกับ {{ $attrs.value.shop_name ? $attrs.value.shop_name : '' }}</div>
            <v-btn
            color="black"
            class="white--text mt-2"
            @click="connectWithTickTok"
            :loading="loading"
            >กดที่นี่ เพื่อเชื่อมต่อ TikTok {{ !!$attrs.value.accessToken ? "อีกครั้ง" : "" }}</v-btn>
          </v-col>
        </v-row>
        <v-row v-if="!!$attrs.value.accessToken">
          <v-col md="6" cols="12">
            <v-select
              v-model="$attrs.value.tiktokWarehouse"
              :items="warehouses"
              label="ผูกกับคลัง *"
              item-text="name"
              item-value="id"
              outlined
              dense
              :rules="[validators.required]"
              :disabled="warehouses.length == 1 && !!$attrs.value.tiktokWarehouse"
              hide-details="auto"
            >
            </v-select>
          </v-col>
        </v-row>
    </div>
</template>
<script>
import { asyncGet } from '@/helpers/asyncAxios'
import { required } from '@core/utils/validation'
export default {
  props: ['defaultSelected'],
  data() {
    return {
      loading: false,
      popupInterval: null,
      warehouses: [],
      validators: {
        required,
      },
    }
  },
  created() {
    if (this.$attrs.value.tiktokWarehouse) {
      this.warehouses = [this.$attrs.value.tiktokWarehouse]
    }
  },
  mounted() {
    // Listen for messages from the popup
    // window.addEventListener('message', this.receiveMessage, false)
  },
  beforeDestroy() {
    // Clean up event listener when component is destroyed
    window.removeEventListener('message', this.receiveMessage)
  },
  methods: {
    async connectWithTickTok() {
      this.loading = true

      window.addEventListener('message', this.receiveMessage, false)

      try {
        const response = await asyncGet('/setting/salechannel/getAuthLink/tiktok')

        const popup = window.open(response, '_blank', '')

        // Optionally, check if popup is closed (if needed)
        const popupInterval = setInterval(() => {
          if (popup.closed) {
            clearInterval(popupInterval)
            console.log('Popup closed.')
            this.loading = false
          }
        }, 500)
      } catch (error) {
        console.log(error)
        this.$root.showCommonDialog('มีปัญหา', this.$errorParser(error))
      }
    },
    receiveMessage(event) {
      const allowedOrigins = [
        'http://localhost:81',
        'http://test.aoocommerce.com',
        'https://test.aoocommerce.com',
        'http://v2.aoocommerce.com',
        'https://v2.aoocommerce.com',
      ]

      if (!allowedOrigins.includes(event.origin)) {
        //console.warn('Origin not allowed:', event.origin)
        return
      }

      console.log(event.data)

      // TODO : Validate granted scopes ?

      const { error, access_token, refresh_token, open_id, seller_name, expired_at, refresh_before, shop, warehouses } =
        event.data

      if (!!error) {
        this.$root.showCommonDialog('มีปัญหา', this.$errorParser(error))
      } else {
        this.$attrs.value.name = seller_name
        this.$attrs.value.shop_name = shop.name

        this.$attrs.value._ref_id = shop.id
        this.$attrs.value.cipher = shop.cipher
        this.$attrs.value.open_id = open_id

        this.$attrs.value.accessToken = access_token
        this.$attrs.value.refreshToken = refresh_token

        this.$attrs.value.expired_at = expired_at
        this.$attrs.value.refresh_before = refresh_before

        this.warehouses = warehouses

        const defaultWarehouse = this.warehouses.find(item => item.is_default)

        if (defaultWarehouse) {
          this.$attrs.value.tiktokWarehouse = defaultWarehouse
        }
      }
    },
  },
}
</script>
